import { jsx as _jsx } from "react/jsx-runtime";
import { MarkdownBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { StaticBlockType } from '@/types';
import { BlockLayout } from '../fragments/BlockLayout';
export const Markdown = ({ block: { content, id, layout, type } }) => {
    const [resolver] = useResolveValue();
    const resolved = {
        content: resolver.resolveString(content)
    };
    const extraStyles = type === StaticBlockType.STATIC_MARKDOWN_INSTRUCTION
        ? {
            bg: 'darkBrandBlue.5',
            borderRadius: 16,
            p: 4
        }
        : {};
    return (_jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(MarkdownBase, { "data-test": id, markdown: resolved.content, sx: extraStyles }) })));
};
